import { Button } from "@/components/ui/button"
import { IconMoon, IconSun } from "@tabler/icons-react"
import { useEffect, useState } from "react"

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    const dark =
      localStorage.getItem("color-theme") === "dark" ||
      (!localStorage.getItem("color-theme") && window.matchMedia("(prefers-color-scheme: dark)").matches)
    setIsDark(dark)
    document.documentElement.classList.toggle("dark", dark)
  }, [])

  const toggle = () => {
    const next = !isDark
    setIsDark(next)
    document.documentElement.classList.toggle("dark", next)
    localStorage.setItem("color-theme", next ? "dark" : "light")
  }

  return (
    <Button variant="ghost" size="icon" onClick={toggle} className="size-8">
      {isDark ? <IconSun className="size-4" /> : <IconMoon className="size-4" />}
      <span className="sr-only">Toggle dark mode</span>
    </Button>
  )
}
